/* global Promise */
( function() {
	document.addEventListener( 'DOMContentLoaded', function() {
		var filterFormEle = document.getElementById( 'main-filter-form' );
		if( !filterFormEle ) { return; }

		var videosEle = document.getElementById( 'video-listing' ),
			genderEle = document.getElementById( 'filter-gender' ),
			dropdownTriggerEle = filterFormEle.querySelector( '#filter-age-group button' ),
			ageCheckboxWrapperEle = document.getElementById( 'filter-age-group' );


		/////
		///// Dropdown Handler
		/////
		dropdownTriggerEle.dataset.textNone = dropdownTriggerEle.textContent.trim(); // stash the original text
		dropdownTriggerEle.addEventListener( 'click', function() {
			var trigger = this;
			var expanded = trigger.getAttribute( 'aria-expanded' ) === 'true';

			var dropdownEle = trigger.nextElementSibling;

			if( dropdownEle.classList.contains( 'filter__dropdown' ) ) {
				dropdownEle.classList.toggle( 'active', !expanded );
			}

			trigger.setAttribute( 'aria-expanded', !expanded );

			if( !expanded ) {
				// on click outside of a tab, close it
				document.body.removeEventListener( 'click', makeActive );

				document.body.addEventListener( 'click', makeActive );
			}

			function makeActive( e ) {
				if(
					dropdownEle.classList.contains( 'active' )
					&& !dropdownEle.contains( e.target )
					&& e.target !== trigger
				) {
					dropdownEle.classList.remove( 'active' );
					trigger.setAttribute( 'aria-expanded', false );
				}
			}
		} );

		/////
		///// Handle "Age" multiselect
		/////
		var ageCheckboxesEles = ageCheckboxWrapperEle.querySelectorAll( 'input' );

		var allAges = Array.from( ageCheckboxesEles ).find( checkbox => checkbox.id === 'age-all' );

		ageCheckboxWrapperEle.addEventListener( 'change', function( e ) {
			// Handle "Select All"
			if( e.target === allAges ) {
				// match all other checkboxes to the select all state
				ageCheckboxesEles.forEach( function( checkbox ) {
					if( checkbox !== e.target )
						checkbox.checked = e.target.checked;
				} );
			} else {
				// adjust the "Select All" based on other checkbox interactions
				var allChecked = Array.from( ageCheckboxesEles ).every( function( checkbox ) {
					return checkbox === allAges || checkbox.checked;
				} );
				
				allAges.checked = allChecked;
			}

			// Update the button text based on what is selected
			var buttonText = '';
			if( allAges.checked ) {
				buttonText = allAges.nextElementSibling.dataset.selectedLabel + ' (' + Array.from( ageCheckboxesEles ).filter( checkbox => checkbox !== allAges ).length + ')';
			} else {
				buttonText = checkboxList( ageCheckboxWrapperEle, true );
				if( !buttonText ) {
					buttonText = dropdownTriggerEle.dataset.textNone;
				}
			}
			dropdownTriggerEle.textContent = buttonText;

			inputChanged();
		} );

		/////
		///// AJAX Trigger
		/////
		filterFormEle.querySelector( 'select' ).addEventListener( 'change', inputChanged );
		var _updateDelay = 1500,
			_actionTimer;
		function inputChanged() {
			if ( _updateDelay > 0 ) {
				// debounce the reload
				clearTimeout( _actionTimer );
				_actionTimer = setTimeout( sendAjaxRequest, _updateDelay );
			} else {
				sendAjaxRequest();
			}
		}

		/////
		///// Sticky Behavior
		/////
		var filterContainerEle = filterFormEle.closest( '.filter' );
		var stickyNavEle = document.querySelector( '.nav-bg' );
		var stickyNavHeight;
		if( stickyNavEle ) {
			stickyNavHeight = stickyNavEle.offsetHeight();
		}

		var placeholder = document.createElement( 'div' );
		placeholder.classList.add( 'filter__pin-placeholder' );
		
		filterContainerEle.parentNode.appendChild( placeholder );

		const observer = new IntersectionObserver( function( entry ) {
			if( entry[0].intersectionRatio === 0 ) {
				const computedStyle = getComputedStyle( filterContainerEle );
				placeholder.style.height = filterContainerEle.offsetHeight + parseInt( computedStyle.marginTop ) + parseInt( computedStyle.marginBottom );
				filterContainerEle.classList.add( 'pinned' );
				filterContainerEle.style.top = stickyNavHeight + 'px';
			} else {
				filterContainerEle.classList.remove( 'pinned' );
				filterContainerEle.style.top = '';
				placeholder.style.height = '';
			}
		}, { threshold: 0 } );
		observer.observe( filterContainerEle.parentElement );
		

		function checkboxList( div, text ) {
			var boxes = div.querySelectorAll( 'input[type="checkbox"]:checked' ),
				combined = [];

			boxes.forEach( function(  checkbox ) {
				var value = text ? checkbox.parentElement.textContent.trim() : parseInt( checkbox.value );

				if( value ) { combined.push( value ); }
			} );

			// text needs spaces between
			return text ? combined.join( ', ' ) : combined.join( ',' );
		}

		function sendAjaxRequest() {
			var METHOD = filterFormEle.getAttribute( 'method' ) || 'POST';

			var requestOptions = {
				method: METHOD,
				headers: {
					'Content-Type': 'text/html; charset=utf-8'
				}
			};

			var params = {
				genders: genderEle.value,
				ages: checkboxList( ageCheckboxWrapperEle )
			};

			var fetchLink = filterFormEle.getAttribute( 'action' ) || '/filter-videos';

			if( METHOD.toLowerCase() == 'get' ) {
				fetchLink += '?' + new URLSearchParams( params ).toString();
			} else {
				requestOptions.body = JSON.stringify( params );
			}
			
			fetch( fetchLink, requestOptions )
				.then( ( response, rejectResponse ) => {
					if ( !response.ok ) {
						return Promise.reject( rejectResponse );
					}
					return response.text();
				} )
				.then( data => {
					videosEle.style.transition = 'opacity 0.5s';
					videosEle.style.opacity = 0;

					videosEle.addEventListener( 'transitionend', function handleTransitionEnd() {
						videosEle.removeEventListener( 'transitionend', handleTransitionEnd ); // Remove the event listener to avoid multiple triggers
						videosEle.innerHTML = data; // Change the content
						videosEle.style.transition = 'opacity 0.5s'; // Change the transition time
						videosEle.style.opacity = 1; // Fade in
					} );
				} )
				.catch( ( error ) => {
					// eslint-disable-next-line no-console
					console.error( 'there was an error ', error );
				} );
		}
	} );
} )();